$(document)
    .on('click', '[data-groups=""]', function () {
        $(this).toggleClass('is_open')
    })
    .on('click', '[data-groups-body=""] > div > *', function (e) {
        // e.preventDefault()
        const parents = $(this).parents('[data-groups]')
        const icn = $('.y-header__groups-option-icn', this).removeClass('y-header__groups-option-icn').addClass('y-header__groups-icn').prop('outerHTML') ?? ''
        const txt = $(this).text().trim()
        const groupsTitleTemplate = `
            <div class="y-header__groups-title is_select">
                ${ icn }
                <span class="y-line-clamp-1">${txt}</span>
            </div>
        `
        $('[data-groups-head=""]', parents).prepend(groupsTitleTemplate)
        setTimeout(()=> $(parents).addClass('is_selected'), 100)
    })
    .on('click', '[data-groups-value]', function (e) {
        e.preventDefault()
        const group_id = $(this).data('groups-value')
        const _token = $('meta[name="csrf-token"]').attr('content')
        const request = $.ajax({
            url: '/student/dashboard/setSessionGroup',
            method: 'post',
            dataType: 'json',
            data: {group_id, _token}
        })
        request.done(response => {
            if (response.success) {
                location.replace('/student/dashboard/')
            }
        })
    })
